import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { COMMON_STATUS } from "../constants/status";
import { logoutUser } from "./common";
import { IStandingOrderItemInfo } from "../interface/IStandingOrderItem";
import StandingOrderItemService from "../service/StandingOrderItemService";
import { RootState } from "../store/store";

export const resetStandingOrderItems = createAction("standingOrderItems/reset");

const _service = new StandingOrderItemService();

type SliceState = {
  // value: IStandingOrderItemInfo | null;
  value: any | null;
  status: string;
  apiCallCount: number;
};

const initialState = {
  value: null,
  status: COMMON_STATUS.INITIAL,
  apiCallCount: 0,
} as SliceState;

export const getStandingOrderItemsAsync = createAsyncThunk(
  "standingOrderItems/setCurrentStandingOrderItems",
  async (params: any) => {
    const response = await _service.getStandingOrdersItemService(params);
    return response;
  }
);

export const standingOrderItemsSlice = createSlice({
  name: "standingOrderItems",
  initialState,
  reducers: {
    setCurrentStandingOrderItems: (state, action) => {
      // console.log(state);
      // console.log(action);
      state.status = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStandingOrderItemsAsync.pending, (state: SliceState) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(
        getStandingOrderItemsAsync.fulfilled,
        (state: SliceState, action) => {
          state.value = action.payload;
          state.status = COMMON_STATUS.LOADED;
        }
      )
      .addCase(getStandingOrderItemsAsync.rejected, (state: SliceState) => {
        state.status = COMMON_STATUS.FAILED;
      })
      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetStandingOrderItems, () => {
        return initialState;
      });
  },
});

export const { setCurrentStandingOrderItems } = standingOrderItemsSlice.actions;

export const getStandingOrderItemList = (state: RootState) =>
  state.standingOrderItems;

export default standingOrderItemsSlice.reducer;
